import { SxProps } from '@mui/material';

import { FONT_ORACLE, TEXT_PRIMARY, TEXT_SECONDARY } from '../constants';

export const imageContainerSx = (height?: number): SxProps => ({
  position: 'relative',
  borderRadius: { xs: '16px', md: '24px' },
  height: height ?? { xs: 200, md: 228 },
  overflow: 'hidden',
});

export const imageSx: SxProps = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

export const badgeSx: SxProps = {
  position: 'absolute',
  bottom: { xs: 8, md: 16 },
  left: { xs: 8, md: 16 },
  background: 'rgba(255,255,255,0.7)',
  backdropFilter: 'blur(3px)',
  WebkitBackdropFilter: 'blur(3px)',
  border: '1px solid white',
  borderRadius: '64px',
  px: { xs: 1.5, md: 2 },
  py: { xs: '3px', md: '4px' },
};

export const badgeTextSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontWeight: 500,
  fontSize: { xs: 13, md: 14 },
  color: TEXT_PRIMARY,
  lineHeight: 1,
};

export const titleSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontWeight: { xs: 400, md: 500 },
  fontSize: { xs: 15, md: 17 },
  color: TEXT_PRIMARY,
  letterSpacing: '-0.34px',
  lineHeight: { xs: '20px', md: 'normal' },
  mt: { xs: 1, md: 2 },
};

export const timeToReadSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontWeight: 400,
  fontSize: { xs: 13, md: 14 },
  color: TEXT_SECONDARY,
  mt: 1,
};
